var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1012.868v-89.042h534.259v89.042h-534.259zM756.869 1012.868v-831.998l-115.481 115.479-62.606-62.609 190.609-192 31.999-30.609 31.999 30.609 190.612 192-62.609 62.609-115.481-115.479v831.998h-89.042zM0 745.736v89.048h445.216v-89.048h-445.216zM0 656.694v-89.042h356.173v89.042h-356.173zM0 389.565v89.044h267.13v-89.044h-267.13zM0 300.522v-89.043h178.086v89.043h-178.086zM0 33.393v89.043h89.043v-89.043h-89.043z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort-asc.7c91d9efbf4e1a931ae019f84082d868.svg";
export { ForwardRef as ReactComponent };